var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFilePpt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#AA3111",
    points: "44,27 4,27 1,23 5,19 43,19 47,23 "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M41,47H7c-1.105,0-2-0.895-2-2V3c0-1.105,0.895-2,2-2l24,0l12,12v32C43,46.105,42.105,47,41,47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3B3B3",
    d: "M31,1v10c0,1.105,0.895,2,2,2h10L31,1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D44519",
    d: "M45,41H3c-1.105,0-2-0.895-2-2V23h46v16C47,40.105,46.105,41,45,41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M16.371,30.645c0,0.878-0.259,1.556-0.776,2.033c-0.518,0.479-1.252,0.717-2.205,0.717h-0.596V36h-2.122 v-7.853h2.718c0.992,0,1.737,0.217,2.234,0.649C16.122,29.23,16.371,29.847,16.371,30.645z M12.793,31.666h0.387 c0.319,0,0.572-0.09,0.76-0.27c0.188-0.179,0.282-0.426,0.282-0.74c0-0.53-0.293-0.795-0.881-0.795h-0.548V31.666z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M23.321,30.645c0,0.878-0.259,1.556-0.776,2.033c-0.518,0.479-1.252,0.717-2.205,0.717h-0.596V36h-2.122 v-7.853h2.718c0.992,0,1.737,0.217,2.234,0.649C23.072,29.23,23.321,29.847,23.321,30.645z M19.744,31.666h0.387 c0.319,0,0.572-0.09,0.76-0.27c0.188-0.179,0.282-0.426,0.282-0.74c0-0.53-0.293-0.795-0.881-0.795h-0.548V31.666z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M28.037,36h-2.122v-6.117h-1.917v-1.735h5.951v1.735h-1.912V36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M38.145,36H35.69l-1.531-2.455L32.645,36h-2.401l2.605-4.018L30.4,28.147h2.353l1.418,2.428l1.364-2.428 h2.422l-2.487,4.001L38.145,36z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilePpt);
export default __webpack_public_path__ + "static/media/icon-file-ppt.c4788a3a75a2ac249295678276938a97.svg";
export { ForwardRef as ReactComponent };